import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tabela-banco',
  templateUrl: './tabela-banco.component.html',
  styleUrls: ['./tabela-banco.component.scss']
})
export class TabelaBancoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
